export const inputMaxNumber = 9999

export const textareaMaxLength = 4000
